import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SmallContainer from '../containers/small/small-container';
import { logoutWithMessage } from '../common/session';
import Seat from '../seat-use/seats';

function PostLoginMenu() {
  const [loading, setLoading] = useState(false);
  const [full, setFull] = useState(false);

  const navigate = useNavigate();
  const handleAppstreamClick = useCallback(async () => {
    if (loading) return; // prevent double clicks
    setLoading(true);
    setFull(false);

    try {
      const res = await fetch(
        process.env.REACT_APP_FACES_API_BASE + '/get-seat',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('facesIDToken')}`,
          },
        }
      );
      if (!res.ok) {
        if (res.status === 409) {
          setFull(true);
        } else {
          throw new Error(`HTTP ${res.status}`);
        }
      }

      const data = await res.json(); // e.g. { url: "https://..." }
      const url = data.streaming_url;
      if (!url) throw new Error('No URL returned from server');

      // Redirect (same tab). Use window.open(url, "_blank") for new tab.
      window.location.assign(url);
    } catch (e) {
      console.error(e.message || 'Failed to get AppStream URL');
    } finally {
      setLoading(false);
    }
  }, [loading]);

  return (
    <SmallContainer>
      {loading && <p>Checking for available seats...</p>}
      {full && (
        <p
          style={{
            fontWeight: 'bold',
            fontSize: '1.1rem',
            marginBottom: '2rem',
          }}
        >
          No seats available. Contact your administrator and try again later.
        </p>
      )}
      <button onClick={handleAppstreamClick} style={{ width: '100%' }}>
        OPEN FACES™
      </button>
      {localStorage.getItem('facesAdmin') === 'true' && (
        <button
          onClick={() => navigate('/menu/admin')}
          style={{ width: '100%' }}
        >
          ACCOUNT ADMINISTRATION
        </button>
      )}
      {localStorage.getItem('facesStaff') === 'true' && (
        <button
          onClick={() => navigate('/menu/faces')}
          style={{ width: '100%' }}
        >
          FACES™ ADMINISTRATION
        </button>
      )}
      <button
        onClick={() => {
          logoutWithMessage('You have been logged out.');
        }}
        style={{ marginTop: '2rem' }}
      >
        LOG OUT
      </button>
      <div style={{ marginTop: '2rem' }}>
        <Seat />
      </div>
    </SmallContainer>
  );
}

export default PostLoginMenu;
